module.exports = {
  headline: 'Starta här',
  title: 'Ny kund hos Spotin',
  text: 'Vänligen fyll in formuläret så att Spotin:s team kan ansluta er',
  titleText: 'Vänligen fyll i detaljerna i formuläret nedan för att göra det möjligt för Spotin att integrera din organisation. För frågor kontakta',
  businessHeader: 'Affärsdetaljer',
  companyNameLabel: 'Företagsnamn',
  businessContactHeader: 'Affärsmässig kontakt',
  businessText: 'Ange kontaktuppgift för affärsutveckling med Spotin. Ex. för möjliga samarbeten med anslutna innehållsmakare.',
  accountingHeader: 'Konto & bokföring',
  accountingText: 'Spotin:s avtal med betalningsförmedlaren används för betalning av slutkunder:s betalning. När ordern betalats förmedlar Spotin betalningen vidare till det bankkonto som anges nedan.',
  bankAccountText: 'Ert företags bankkonto som Spotin ska skicka betalningar från kunder till.',
  bankAccountLabel: 'Bankkonto',
  accountingEmailText: 'Epost som bokföringsmässigt avräkningsunderlag ska skickas till.',
  technicalHeader: 'Tekniska detaljer',
  technicalContactHeader: 'Teknisk kontakt',
  technicalContactText: 'Ange kontaktuppgift för teknisk kontakt för initialt integrationsmöte och eventuella förtydliganden om ert specifika system och/eller data.',
  platformHeader: 'E-handelsplattform',
  platformText: 'Berätta om platformen som du använder så vi kan integrera er med Spotin.',
  otherDetailsText: 'Andra detaljer som är relevant för integrationen (exempelvis affärsystem som används) så kan ni ange detta nedan. Detaljer behandlas vid integrationsmötet av Spotin:s integrationsteam som hålls med er i samband med att integrationsarbetet påbörjas av Spotin.',
  selectDefault: 'Välj',
  otherPlatformLabel: '(Om annan)',
  platformVersionLabel: 'Plattformsversion',
  additionalDetailsLabel: 'Övriga detaljer (valfritt)',
  mailOrderHeader: 'Order via Mejl (Valfritt)',
  mailOrderText: 'Spotin har ett kompletterande ordersystem där ni kan motta ordrar via mejl och manuellt föra in dem i ert system. Detta system används:', 
  mailOrderUseCase1: 'Ifall ett fullständig orderintegrationsstöd inte ännu är tillgänglig för den e-handelsplattform eller affärssystem som integration görs mot. (I sådant fall kan mejlordersystemet användas tills dess att en fullständig orderintegration finns tillgänglig, för att komma igång med er försäljning genom Spotin.)',
  mailOrderUseCase2: 'Som backup vid fel hos den primära orderintegrationen.',
  mailOrderConfirmationText: 'Bekräfta att ni är vill använda mejlordersystemet som beskrivs ovan:',
  mailOrderConfirm: 'Ja (Rekommenderas)',
  mailOrderDecline: 'Nej',
  mailOrderEmailText: 'E-post som ordrar skall skickas till. (Vid ja ovan).',
  logoText: 'Logotypen ska uppfyllande följande:',
  logoRequirement1: 'Logotypen ska vara i vektorbaserat format. SVG (rekommenderas), EPS, AI eller motsvarande filformat, max 5 MB',
  logoRequirement2: 'Bakgrunden på logotypen ska vara transparent',
  logoRequirement3: '(Valfritt) Ifall ni har en svart och vit version av logotypen, eller mindre versioner av logotypen så rekommenderar vi att ni inkluderar dessa versioner',
  logoRequirement4: 'Alternativt kan du maila logotyperna till',
  mailto: 'info@spotin.com',
  buttonText: 'Skicka',
  altText: 'Eller skicka oss epost:',
  sentHtml: `Epost skickat<br><br>Vi återkommer till dig inom kort.<br><br><br>Vänliga hälsningar<br><br>Spotin<br><br><br>`,
  errorFileTooLargeHtml: `Epost kunde inte skickas<br><br>Filstorleken på en eller flera logotyper var större än 5 MB.<br>Kontakta oss om du inte kan minimera filstorleken.<br><br><br>Vänliga hälsningar<br><br>Spotin<br><br><br>`,
  errorGenericHtml: `Epost kunde inte skickas<br><br>Något gick fel när formuläret skickades<br>Kontakta oss om detta.<br><br><br>Vänliga hälsningar<br><br>Spotin<br><br><br>`,
  nameLabel: 'Namn',
  emailLabel: 'Epost',
  phoneLabel: 'Telefon',
  subjectLabel: 'Ämne',
  messageLabel: 'Meddelande',
};



// WEBPACK FOOTER //
// ./pages/content/integration_SV.js